/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'confluence.error.panel.refresh.app': 'Obnovit aplikaci',
  'confluence.error.panel.reload.page': 'Znovu načíst stránku',
  'confluence.icon.label': 'Ikona',
  'confluence.modal.dialog.close.modal.button': 'Zrušit',
  'confluence.select.required.field.message': 'Toto pole je povinné.',
  'confluence.text.area.required.field.message': 'Toto pole je povinné.',
  'confluence.textfield.validator.email': 'Zadejte platný e-mail.',
  'confluence.textfield.validator.number': 'Zadejte platné číslo',
  'confluence.textfield.validator.required.field.message': 'Toto pole je povinné.',
  'confluence.textfield.validator.telephone': 'Zadejte platný telefon.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Je potřeba přístup',
  'confluence.threeLOPrompt.modal.error.title': 'Chyba',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'Adresa URL souhlasu nebyla nalezena. Obnovte stránku a zkuste to znovu.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'Adresa URL souhlasu nebyla nalezena. Obnovte stránku a zkuste to znovu.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Povolit přístup',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Konfigurovat přístup',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Ověření se nezdařilo.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'Aplikaci {appString} lze zobrazit až poté, co jí povolíte přístup vaším jménem k produktům Atlassian.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    'Aplikace {appString} vyžaduje další přístup k vašemu účtu.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Upozornění na externí ověření',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'tato aplikace',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Tato aplikace',
  'confluence.user.group.unknown.user.message': 'Neznámý uživatel',
  'confluence.user.picker.empty.field.error.message': 'Toto pole je povinné.',
  'confluence.user.unknown.user.message': 'Neznámý uživatel',
  'forge-ui.form.submit-button.text': 'Odeslat',
};
